import { render, staticRenderFns } from "./UnstakeDialog.vue?vue&type=template&id=328d8ec6&scoped=true&"
import script from "./UnstakeDialog.vue?vue&type=script&lang=js&"
export * from "./UnstakeDialog.vue?vue&type=script&lang=js&"
import style0 from "./UnstakeDialog.vue?vue&type=style&index=0&id=328d8ec6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d8ec6",
  null
  
)

export default component.exports